import { MenuItem } from '@src/common/components/Menu';
import type { OrderListing } from '@src/orders/domain/OrderList';
import { OrderActions } from '@src/orders/domain/OrderList';
import { useCurrentOrderMode } from '@src/orders/hooks/useCurrentOrderMode';
import { useTranslation } from 'react-i18next';

type Props = {
  order: OrderListing;
};
export const ViewInvoiceAction = ({ order }: Props) => {
  const { t } = useTranslation();
  const { setCurrentMode } = useCurrentOrderMode();

  const viewInvoice = () => setCurrentMode({ mode: 'viewInvoice' });

  return (
    order.canDo(OrderActions.VIEW_INVOICE) && (
      <MenuItem key={`${order.id}-view-invoice`} onClick={viewInvoice}>
        {t('viewInvoice')}
      </MenuItem>
    )
  );
};
